<template>
  <div class="store_good_list" :style="{'overflow-y' : overflowY}">
    <!--tabs切换-->
    <div class="baby_manage_tabs_box">
      <ul>
        <!--<li v-for="(item, index) in tabsList"
            :key="index"
            @click="tabsChange(item.value)">{{item.name}}</li>-->
        <!--:class="{'active': type === item.value}"-->
        <li class="active">店铺货品列表</li>
        <li @click="tabsChange('storeLinkList')">店铺链接列表</li>
        <li @click="tabsChange('cannotLinkList')">无法识别链接列表</li>
      </ul>
    </div>
    <!--店铺货品列表模糊查询-->
    <div class="store_good_list_top">
      <div class="first_line">
        <div>
          <el-select v-model="selectStore" :value="selectStore" placeholder="店铺">
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectChannel" :value="selectChannel" placeholder="渠道">
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectInventoryDocking" :value="selectInventoryDocking" placeholder="库存对接状态">
            <el-option
              v-for="item in inventoryDockingList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectPublicStatus" :value="selectPublicStatus" placeholder="货品发布状态">
            <el-option
              v-for="item in publicStatusList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectTimeType" :value="selectTimeType" placeholder="查询时间">
            <el-option
              v-for="item in timeTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="start_time">
          <el-date-picker
            v-model.trim="startTime"
            type="date"
            placeholder="开始时间"
            format="yyyy/MM/dd">
          </el-date-picker>
        </div>
        <span>至</span>
        <div class="end_time" style="margin-left: 0.5%">
          <el-date-picker
            v-model.trim="endTime"
            type="date"
            placeholder="结束时间"
            format="yyyy/MM/dd">
          </el-date-picker>
        </div>
      </div>
      <div class="second_line">
        <div>
          <el-select v-model="selectBrand" :value="selectBrand" placeholder="品牌">
            <el-option
              v-for="item in brandsList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectCodeSegment" :value="selectCodeSegment" placeholder="码段">
            <el-option
              v-for="item in codeSegmentList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectGoodsType" :value="selectGoodsType" placeholder="分类">
            <el-option
              v-for="item in goodsTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectOnState" :value="selectOnState" placeholder="上架状态">
            <el-option
              v-for="item in onStateList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        库存
        <div class="inventory_list" style="margin-left: 0.5%">
          <el-select v-model="selectInventorySymbol" :value="selectInventorySymbol" placeholder="符号">
            <el-option
              v-for="item in inventorySymbolList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="inventory_msg">
          <input type="text" maxlength="10" v-model.number="inventory" @keyup="judgeNum()" placeholder="库存">
        </div>
        <div class="goods_name">
          <input type="text" v-model.trim="goodsNum" placeholder="货号/品名">
        </div>
        <button class="btn_normal w116" @click="queryData()">查询</button>
      </div>
      <div class="third_line mb5">
        <button class="btn_normal" @click="ctrlBtn('batchSetInventoryDocking')">批量设置货号库存对接</button>
        <button class="btn_normal" @click="ctrlBtn('batchCloseInventoryDocking')">批量关闭货号库存对接</button>
        <button class="btn_normal" @click="exportShopGoodsExcel()">店铺货品导出</button>
      </div>
    </div>

    <!--店铺货品列表信息-->
    <div class="store_good_list_msg">
      <!--表格-->
      <table class="table tb_border">
        <thead>
        <tr>
          <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
          <th>货号</th>
          <th>品名</th>
          <th>品牌</th>
          <th>上市季节</th>
          <th>库存</th>
          <th>对接状态</th>
          <th>发布状态</th>
          <th>上架状态</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <!--<td rowspan="3"><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>-->
          <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
          <td>{{item.GoodsId}}</td>
          <td>{{item.GoodsName}}</td>
          <td>{{item.BrandName}}</td>
          <td>{{item.MarketSeasoin}}</td>
          <td>{{item.Stock}}</td>
          <td>{{item.StockStatus | inventorydocking}}</td>
          <td>{{item.PubStatus | publishstatus}}</td>
          <td>{{item.GroundingStatus | onstate}}</td>
          <td>
            <a title="货品详情" @click="ctrlBtn('goodDetail', item)">货品详情</a>
            <a title="链接详情" @click="ctrlBtn('sglLinkDetail', item)">链接详情</a>
            <a title="设置库存对接" @click="ctrlBtn('setInventoryDocking', item)">设置库存对接</a>
            <a title="同步库存" @click="ctrlBtn('sglSynchronizationOfInventory', item)">同步库存</a>
            <a title="上下架" @click="ctrlBtn('numUpDown', item)">上下架</a>
          </td>
        </tr>
       <!-- <tr>
          <td>916055-091</td>
          <td>Sk8-Hi</td>
          <td>VANS</td>
          <td>2018Q1</td>
          <td>80</td>
          <td>关闭</td>
          <td>已发布</td>
          <td>已上架</td>
          <td>
            <a title="货品详情" @click="ctrlBtn('goodDetail', 'item')">货品详情</a>
            <a title="链接详情" @click="ctrlBtn('sglLinkDetail', 'item')">链接详情</a>
            <a title="设置库存对接" @click="ctrlBtn('setInventoryDocking', 'item')">设置库存对接</a>
            <a title="同步库存" @click="ctrlBtn('sglSynchronizationOfInventory', 'item')">同步库存</a>
            <a title="上下架" @click="ctrlBtn('numUpDown', 'item')">上下架</a>
          </td>
        </tr> -->
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="10">暂时没有相关信息</td>
        </tr>
        </tbody>
        <!-- <tbody v-if="!list.length">
        <tr>
          <td colspan="4">暂时没有相关的数据</td>
        </tr>
        </tbody> -->
      </table>

      <!--分页-->
      <div class="paging" v-if="list.length">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <store-good-list-embed-msg v-if="isShow"
                               :title="dialogTitle"
                               :goodMsg="goodMsg"
                               :shopId="selectStore"
                               :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></store-good-list-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import StoreGoodListEmbedMsg from './store-good-list-embed-msg';
  import MsgDialog from '../../../public-component/msg-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

  export default {
    name: 'store-good-list',
    components: {StoreGoodListEmbedMsg, MsgDialog, LoadingDialog},
    watch: {
      'isShow': function (val) {
        if (val) {
          this.overflowY = 'hidden';
        } else {
          this.overflowY = 'auto';
        }
      },
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    data() {
      return {
        list: [], // 列表信息
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        storeList: [], // 店铺下拉
        selectStore: '', // 店铺选择
        channelList: [
          {id: '', text: '所有渠道'}
        ], // 渠道下拉
        selectChannel: '', // 渠道选择
        inventoryDockingList: [
          {id: 0, text: '库存对接状态'},
          {id: 1, text: '开启'},
          {id: 2, text: '关闭'}
        ], // 库存对接状态下拉
        selectInventoryDocking: 0, // 对接状态选择
        publicStatusList: [
          {id: 0, text: '货品发布状态'},
          {id: 1, text: '已发布'},
          {id: 2, text: '未发布'}
        ], // 货品发布状态下拉
        selectPublicStatus: 0, // 货品发布状态选择
        timeTypeList: [
          {id: 0, text: '查询时间'},
          {id: 1, text: '上市时间'},
          {id: 2, text: '创建时间'}
        ], // 查询时间下拉
        selectTimeType: 0, // 查询时间选择
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        brandsList: [
          {id: '', text: '所有品牌'}
        ], // 品牌下拉
        selectBrand: '', // 品牌选择
        codeSegmentList: [
          {id: '', text: '所有码段'}
        ], // 码段下拉
        selectCodeSegment: '', // 码段选择
        goodsTypeList: [], // 商品分类下拉
        selectGoodsType: '', // 商品分类选择
        onStateList: [
          {id: 0, text: '上架状态'},
          {id: 1, text: '已上架'},
          {id: 2, text: '部分上架'},
          {id: 3, text: '已下架'}
        ], // 上架状态下拉
        selectOnState: 0, // 上架状态选择
        inventorySymbolList: [
          {id: 0, text: '符号'},
          {id: 1, text: '='},
          {id: 2, text: '>'},
          {id: 3, text: '>='},
          {id: 4, text: '<'},
          {id: 5, text: '<='}
        ], // 库存符号下拉
        selectInventorySymbol: 0, // 库存符号选择
        inventory: '', // 库存信息
        goodsNum: '', // 货号/品名
        overflowY: 'auto', // 是否出现滚动
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].id;
              this.loadAllShopGoodsPageData();
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannel = '';
          } else {
            this.channelList = [];
            this.selectChannel = res.data.errorMsg;
          }
        });
      },

      // 加载品牌下拉数据
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandsList = res.data.resData;
            this.brandsList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrand = '';
          } else {
            this.brandsList = [];
            this.selectBrand = res.data.errorMsg;
          }
        });
      },

      // 加载码段下拉数据
      getAllSizeGroupList() {
        this.$axios.get(this.Global.getAllSizeGroupList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeSegmentList = res.data.resData;
            this.codeSegmentList.splice(0, 0, {id: '', text: '所有码段'});
            this.selectCodeSegment = '';
          } else {
            this.codeSegmentList = [];
            this.selectCodeSegment = res.data.errorMsg;
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.goodsTypeList = res.data.resData;
            this.goodsTypeList.splice(0, 0, {id: '', text: '所有分类'});
            this.selectGoodsType = '';
          } else {
            this.goodsTypeList = [];
            this.selectGoodsType = res.data.errorMsg;
          }
        });
      },

      // 根据查询条件查询数据
      queryData() {
        this.currentPage = 1;
        this.loadAllShopGoodsPageData();
      },

      // 获取店铺货品列表分页数据
      loadAllShopGoodsPageData() {
        this.isLoading = true;
        const params = {
          idOrName: this.goodsNum, // 货品id或名称
          shopId: this.selectStore, // 店铺id
          storeroomId: this.selectChannel, // 渠道id
          stockStatus: this.selectInventoryDocking, //  库存对接状态
          goodsPubStatus: this.selectPublicStatus, // 货品发布状态
          selDatetime: this.selectTimeType, // 查询时间
          beginQueryTime: this.Global.timeFormatStart(this.startTime), // 开始上市时间
          endQueryTime: this.Global.timeFormatEnd(this.endTime), // 结束上市时间
          brandId: this.selectBrand, // 品牌id
          sGId: this.selectCodeSegment, // 码段id
          classId: this.selectGoodsType, // 分类id
          goodsGroundingStatus: this.selectOnState, // 上架状态
          symbol: this.selectInventorySymbol, // 符号
          stcok: this.inventory, // 库存
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAllShopGoodsPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res) {
              clearTimeout(timer);
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < res.data.resData.DataList.length; i++) {
                  self.checkboxModel.push(false);
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 店铺货品列表 导出excel
      exportShopGoodsExcel() {
        const params = {
        idOrName: this.goodsNum, // 货品id或名称
        shopId: this.selectStore, // 店铺id
        storeroomId: this.selectChannel, // 渠道id
        stockStatus: this.selectInventoryDocking, //  库存对接状态
        goodsPubStatus: this.selectPublicStatus, // 货品发布状态
        selDatetime: this.selectTimeType, // 查询时间
        beginQueryTime: this.Global.timeFormatStart(this.startTime), // 开始上市时间
        endQueryTime: this.Global.timeFormatEnd(this.endTime), // 结束上市时间
        brandId: this.selectBrand, // 品牌id
        sGId: this.selectCodeSegment, // 码段id
        classId: this.selectGoodsType, // 分类id
        goodsGroundingStatus: this.selectOnState, // 上架状态
        symbol: this.selectInventorySymbol, // 符号
        stcok: this.inventory, // 库存
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      };
        this.$axios.post(this.Global.exportShopGoodsExcel, params).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的货号';
          }
        });
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 操作按钮
      ctrlBtn(type, goodMsg) {
        this.dialogShowType = type;
        this.goodMsg = goodMsg;
        switch (type) {
          case 'goodDetail':
            this.isShow = true;
            this.dialogTitle = '货品详情';
            break;
          case 'sglLinkDetail':
            this.isShow = true;
            this.$set(this.goodMsg, 'shopId', this.selectStore);
            this.dialogTitle = '链接详情';
            break;
          case 'setInventoryDocking':
            this.isShow = true;
            this.dialogTitle = '设置库存对接';
            this.goodMsg.shopId = this.selectStore;
            break;
          case 'sglSynchronizationOfInventory':
            this.isShow = true;
            this.dialogTitle = '同步库存';
            break;
          case 'numUpDown':
            this.isShow = true;
            this.dialogTitle = '上下架';
            break;
          case 'batchSetInventoryDocking':
          case 'batchCloseInventoryDocking':
            let checkboxModelLst = []; // 选择的货号
            this.checkboxModel.findIndex((val, i) => {
              if (val === true) {
                checkboxModelLst.push(this.list[i].GoodsId);
              }
            });
            if (!checkboxModelLst.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择要批量操作的货号';
              return;
            }
            this.isShow = true;
            this.goodMsg = {
              shopId: this.selectStore,
              checkboxModelLst: checkboxModelLst
            };
            this.goodMsg.checkboxModelLst = checkboxModelLst;
            if (type === 'batchSetInventoryDocking') {
              this.dialogTitle = '批量设置货号库存对接';
            } else {
              this.dialogTitle = '批量关闭货号库存对接';
            }
            break;
        }
      },

      // 判断是否是数字
      judgeNum() {
        if (!Number(this.inventory)) {
          this.inventory = 0;
        }
        this.inventory = parseInt(this.inventory);
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.isMsg = true;
          this.isSuc = true;
          this.txtMsg = '操作成功';
          this.loadAllShopGoodsPageData();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAllShopGoodsPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAllShopGoodsPageData();
      },

      // tabs切换
      tabsChange(value) {
        this.$emit('tabschange', {type: value});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      // 获取店铺下拉框信息
      this.getAllPXShopList();
      // 获取渠道下拉框信息
      this.getAllStoreroomsList();
      // 加载品牌下拉数据
      this.getAllBrandsList();
      // 加载码段下拉数据
      this.getAllSizeGroupList();
      // 加载分类下拉数据
      this.getAllClassList();
      // 获取店铺货品列表分页数据
      // this.loadAllShopGoodsPageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        // console.log(this.storeList);
       /* if (this.storeList.length > 0) {
          this.selectStore = this.storeList[0].id;
        } */
        this.selectChannel = '';
        this.selectInventoryDocking = 0;
        this.selectPublicStatus = 0;
        this.selectTimeType = 0;
        this.startTime = '';
        this.endTime = '';
        this.selectBrand = '';
        this.selectCodeSegment = '';
        this.selectGoodsType = '';
        this.selectOnState = 0;
        this.selectInventorySymbol = 0;
        this.inventory = '';
        this.goodsNum = '';
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        // this.loadAllShopGoodsPageData();
        // 获取店铺下拉框信息
        this.getAllPXShopList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .store_good_list {
    .store_good_list_top {
      .first_line, .second_line, .third_line {
        width: 100%;
        margin: 10px 0;

        & > div {
          display: inline-block;
          width: 12%;
          margin-right: 0.5%;

          &:nth-child(1) {
            margin-left: 1%;
          }
        }

        & > button {
          &:nth-child(1) {
            margin-left: 1%;
          }
        }

        .start_time, .end_time {
          width: 15%;
        }

        .inventory_list {
          width: 8%;
        }

        .inventory_msg {
          width: 9%;
        }

        .goods_name {
          width: 10%;
        }
      }
    }

    .store_good_list_msg {
      height: calc(100% - 185px);

      .paging {
        width: 100%;
        max-width: 100%;
        text-align: right;
        margin: 20px 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/store-good-list.vue